/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2024, Zumper
 * @description useAirbnbFriendly
 */

import { useRouteProps } from '@zcode-ui/hook'
import { selectPathname } from '@zcode-ui/web-zumper-global-state'
import { checkDetailView } from '@zcode/zumper-routes'
import { airBnbFriendlyPathnames } from './constants'

export const useAirbnbFriendly = () => {
  const routeProps = useRouteProps()
  const pathname = selectPathname(routeProps) ?? ''
  const isAirbnbFriendlyMarket = airBnbFriendlyPathnames.some((airBnbFriendlyPathname) =>
    pathname.includes(airBnbFriendlyPathname)
  )
  const isDetailView = checkDetailView(routeProps)
  return isAirbnbFriendlyMarket || isDetailView
}
